import React from 'react';

const MultilineText = (props) => {
  return <div style={{ whiteSpace: 'pre-line' }} {...props} />;
};

export default MultilineText;
